;(function (factory) {
   if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(['jquery'], factory);
   } else {
      // Browser globals
      factory(window.$svjq);
   }
} (function ($) {

   // Static {{{
   var PLUGIN_NAMESPACE = 'triggeredInput',
      KEY = {
         DOWN: 40,
         UP: 38,
         ESC: 27,
         TAB: 9,
         ENTER: 13
      },
      WORD_CHARS = '\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0525\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0621-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971\u0972\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D3D\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC\u0EDD\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8B\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10D0-\u10FA\u10FC\u1100-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u2094\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2D00-\u2D25\u2D30-\u2D65\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31B7\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCB\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA65F\uA662-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B\uA78C\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA2D\uFA30-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
   // }}}

   // Helpers {{{
   /**
    * Object.keys shim. Used to get all keys from an object as an array
    * Will use built in function if it exists otherwise we'll have to iterate
    * the keys by our selves...
    * @param {object} the object to get the keys from
    * @return {array} an array with the keys
    */
   function getKeys(obj) {
      var result,
         key;

      if (window.Object.keys) {
         return window.Object.keys(obj);
      } else {
         result = [];
         for (key in obj) {
            if (obj.hasOwnProperty(key)) {
               result.push(key);
            }
         }
         return result;
      }
   }

   /**
    * StartsWith shim will use built in method if it exists
    * otherwise fallback and use indexOf.
    * @param {string} the string to be compared
    * @param {string} the string to compare with
    * @return {boolean} Returns true if the first param starts
    * with the second
    */
   function startsWith(string, strtsWith) {
      if (string.startsWith) {
         return string.startsWith(strtsWith);
      } else {
         return string.indexOf(strtsWith) === 0;
      }
   }
   // }}}

   // View defaults {{{
   var viewDefaults = {

      renderOne: function(item) {
         var result = '';
         if ($.isPlainObject(item)) {
            if (item.iconURL) {
               result += '<img src="' + item.iconURL + '" alt="" />';
            }

            if (item.name) {
               result += '<span>' + item.name + '</span>';
            }

            if (item.description) {
               result += ' <small>' + item.description + '</small>';
            }
         } else {
            result += '<span>' + item + '</span>';
         }

         return result;
      },

      left: function($el) {
         var offset = $el.offset().left,
            marginLeft = $el.css('margin-left');

         if (marginLeft) {
            offset += parseInt(marginLeft, 10);
         }
         return offset + 'px';
      },

      top: function($el) {
         var offset = $el.offset().top + $el.height();

         offset += (parseInt($el.css('padding-top'), 10) || 0);
         offset += (parseInt($el.css('padding-bottom'), 10) || 0);
         offset += (parseInt($el.css('border-top'), 10) || 0);
         offset += (parseInt($el.css('border-bottom'), 10) || 0);

         return offset + 'px';
      },

      width: function($el) {
         var width = $el.width();

         width += (parseInt($el.css('padding-left'), 10) || 0);
         width += (parseInt($el.css('padding-right'), 10) || 0);
         width += (parseInt($el.css('border-left'), 10) || 0);
         width += (parseInt($el.css('border-right'), 10) || 0);

         return width + 'px';
      }

   };
   // }}}

   // View {{{
   /**
    * @constructor
    */
   function View(el, opts) {
      this.el = el;
      this.$el = $(el);
      this.options = $.extend(true, {}, viewDefaults, opts);
      this.collection = [];

      this.init();
   }

   View.prototype = {

      init: function() {
         this.$list = $('<ul/>')
            .addClass(PLUGIN_NAMESPACE + '-data-list')
            .css({
               'display'   : 'none',
               'position'  : 'absolute'
            })
            .appendTo('body');

         if (this.options.listClassName) {
            this.$list.addClass(this.options.listClassName);
         }

         this.bindEvents();
      },

      setPosition: function() {
         var opts = this.options;
         this.$list.css({
            'left'      : $.isFunction(opts.left) ? opts.left.call(this, this.$el) : opts.left,
            'top'       : $.isFunction(opts.top) ? opts.top.call(this, this.$el) : opts.top,
            'width'     : $.isFunction(opts.width) ? opts.width.call(this, this.$el) : opts.width
         });
      },

      bindEvents: function() {
         var that = this;
         this.$list
            .on('click.' + PLUGIN_NAMESPACE, 'li', function() {
               that.handleClick.call(that, this);
            })
            .on('mouseenter.' + PLUGIN_NAMESPACE, 'li', function() {
               that.setSelectedIndex.call(that, $(this).index());
            });
      },

      handleClick: function(element) {
         this.setSelectedIndex($(element).index());
         this.select();
      },

      setTrigger: function(trigger) {
         this.trigger = trigger;
         return this;
      },

      setCollection: function(items) {
         this.collection = items;
         return this;
      },

      render: function(items) {
         var i = 0, l, result = '';

         this.collection = items || this.collection;
         l = this.collection.length;

         if (l === 0) {
            this.$list.hide();
            return;
         }

         this.setPosition();

         for (; i < l; i ++) {
            result += i === 0 ? '<li class="selected">' : '<li>';
            result += this.options.renderOne(this.collection[i]);
            result += '</li>';
         }

         this.$list
            .empty()
            .append(result)
            .show();
      },

      isVisible: function() {
         return this.$list.is(':visible');
      },

      show: function() {
         this.$list.show();
      },

      hide: function() {
         this.$list.hide();
      },

      getSelectedItem: function() {
         var item = this.collection[this.getSelectedIndex()];
         return $.isPlainObject(item) ? item : {name: item};
      },

      getSelectedElement: function() {
         return this.$list.find('.selected');
      },

      getSelectedIndex: function() {
         return this.getSelectedElement().index();
      },

      setSelectedIndex: function(index) {
         var lis = this.$list.find('li'),
            length = lis.length;

         lis.removeClass('selected');

         if (index < 0) {
            index = length - 1;
         } else if (index >= length) {
            index = 0;
         }

         lis.eq(index).addClass('selected');
      },

      select: function() {
         this.$el.trigger('insert-text.' + PLUGIN_NAMESPACE, $.extend({}, {trigger: this.trigger}, this.getSelectedItem()));
         this.hide();
      },

      next: function() {
         this.setSelectedIndex(this.getSelectedIndex() + 1);
      },

      prev: function() {
         this.setSelectedIndex(this.getSelectedIndex() - 1);
      }
   }; // END View.prototype
   // }}}

   // Cache {{{

   /**
    * @constructor
    */
   function Cache(ttl) {
      this.entries = {};
      this.ttl = ttl;
   }

   Cache.prototype = {

      addEntry: function(query, cacheEntry) {
         this.entries[query] = cacheEntry;
      },

      getEntry: function(query) {
         var entry = this.entries[query];

         if (entry && entry.isValid(this.ttl)) {
            return entry;
         } else if (entry) {
            this.removeEntry(query);
         }

         return false;
      },

      removeEntry: function(query) {
         delete this.entries[query];
      },

      /**
       * Search the cache for previous queries that have been
       * executed and have returned an empty result.
       * @param {string} the query
       * @return {string} if a previous query is found it will be returned otherwise
       * we'll return the query param
       */
      checkForExistingQuery: function(query) {
         var keys = getKeys(this.entries),
            i = 0,
            l = keys.length,
            key;

         for (; i < l; i ++) {
            key = keys[i];
            if (key.length <= query.length &&
               startsWith(query, key) &&
               this.entries[key].isEmpty()) {
               return key;
            }
         }

         return query;
      }
   };
   // }}}

   // Cache Entry {{{

   /**
    * @constructor
    */
   function CacheEntry(data) {
      this.data = data;
      this.timeStamp = new Date().getTime();
   }

   CacheEntry.prototype = {

      isValid: function(ttl) {
         return ((new Date().getTime() - this.timeStamp) / 1000) < ttl;
      },

      isEmpty: function() {
         return !this.data || this.data.length === 0;
      },

      getData: function() {
         return this.data;
      }
   };
   // }}}

   // Controller Defaults {{{
   var controllerDefaults = {
      triggers: {
         '@': {
            source: [],
            searchKey: 'query',
            allowWhiteSpace: false,
            useCache: true,
            ttl: 120,
            parse: function(response) {
               return response;
            }
         }
      },
      delay: 200,
      minLength: 1,
      replacer: function(item) {
         return item.trigger + '[' + item.id + ':' + item.name + ']';
      }
   };
   // }}}

   // Controller {{{

   /**
    * @constructor
    */
   function Controller(el, opts) {
      this.idArray = [];
      this.el = el;
      this.$el = $(el);
      this.caretPosition = 0;
      this.options = $.extend(true, {}, controllerDefaults, opts);

      this.createHiddenInput();
      this.bindEvents();

      this.view = new View(this.el, opts);

      this.cache = {};
   }

   Controller.prototype = {

      bindEvents: function() {
         var that = this;
         this.$el
            .on('change.' + PLUGIN_NAMESPACE + 'blur.' + PLUGIN_NAMESPACE, function(e) {
               that.updateHiddenInput.call(that);
            })
            .on('focus.' + PLUGIN_NAMESPACE, function(e) {
               that.handleInput.call(that);
            })
            .on('keyup.' + PLUGIN_NAMESPACE, function(e) {
               return that.handleKeyUp.call(that, e);
            })
            .on('keydown.' + PLUGIN_NAMESPACE, function(e) {
               return that.handleKeyDown.call(that, e);
            })
            .on('insert-text.' + PLUGIN_NAMESPACE, function(e, opts) {
               that.insertItem.call(that, opts);
            });

         this.$el.closest('form')
            .on('submit', function(e) {
               that.updateHiddenInput.call(that, e);
            });
      },

      createHiddenInput: function() {
         this.$hiddenInput = $('<input type="hidden" disabled />');
         this.$hiddenInput.insertAfter(this.$el);
      },

      getRichContent: function() {
         var i = 0, l,
            content = this.el.value,
            item,
            endIndex,
            result = '';

         this.validateItems();

         l = this.idArray.length;
         for (; i < l; i ++) {
            item = this.idArray[i];
            endIndex = content.indexOf(item.trigger + item.name) + (item.trigger + item.name).length;
            result += content.substring(0, endIndex);
            result = result.replace(item.trigger + item.name, this.options.replacer(item));

            content = content.substring(endIndex);
         }

         result += content;
         return result;
      },

      setIds: function(ids) {
         this.idArray = ids;
      },

      getIdArray: function() {
         return this.idArray;
      },

      updateHiddenInput: function() {
         this.$hiddenInput.val(this.getRichContent());
      },

      handleKeyDown: function(e) {
         if (!this.view.isVisible()) {
            return;
         }

         switch (e.which) {
            case KEY.ESC:
               e.preventDefault();
               this.view.hide();
               break;
            case KEY.UP:
               e.preventDefault();
               this.view.prev();
               break;
            case KEY.DOWN:
               e.preventDefault();
               this.view.next();
               break;
            case KEY.ENTER:
            case KEY.TAB:
               e.preventDefault();
               this.view.select();
               break;
         }

         return e.stopPropagation();
      },

      handleKeyUp: function(e) {
         switch (e.which) {
            case KEY.ESC:
               e.preventDefault();
               this.view.hide();
               break;
            case KEY.UP:
            case KEY.DOWN:
               if (this.view.isVisible()) {
                  e.preventDefault();
               }
               break;
            case KEY.TAB:
            case KEY.ENTER:
                  e.preventDefault();
                  break;
            default:
               this.handleInput();
               break;
         }
      },

      getTrigger: function(trigger) {
         return this.options.triggers[trigger];
      },

      handleInput: function() {

         // check caret pos
         this.updateCaretPosition();

         var query = this.getQuery();

         if (!query ||
            query.value.length < this.options.minLength) {
            this.view.hide();
            return;
         }

         this.search(query);

      },

      /**
       * Search for objects based on the given query.
       * If the source for the active trigger is an array,
       * it will filter the array. And if the source is an URL,
       * it will do an AJAX-request to get the result.
       *
       * @param
       */
      search: function(query) {
         var that = this,
            source = this.getTrigger(query.trigger).source,
            result;

         if ($.isArray(source)) {
            result = $.grep(source, function(element) {
               var str = query.value.toLowerCase();
               if ($.isPlainObject(element)) {
                  return element.name.toLowerCase().indexOf(str) > -1;
               } else {
                  return element.toLowerCase().indexOf(str) > -1;
               }
            });

            this.view
               .setTrigger(query.trigger)
               .setCollection(result).render();
         } else {

            if (this.serverRequestTimer) {
               window.clearTimeout(this.serverRequestTimer);
            }

            this.serverRequestTimer = window.setTimeout(function() {
               $.when(that.sendServerRequest(query))
                  .then(function(response) {
                     var parsedResponse;
                     if (response instanceof CacheEntry) {
                        parsedResponse = response.getData();
                     } else {
                        parsedResponse = that.getTrigger(query.trigger).parse(response);
                     }
                     that.view.setTrigger.call(that.view, query.trigger);
                     that.view.setCollection.call(that.view, parsedResponse);
                     that.view.render.call(that.view);
                  });
            }, this.options.typeDelay);
         }
      },

      /**
       * Get the cache for a specific trigger. If the cache
       * don't exist it will be created.
       * @param {string} a string that represents the trigger
       * @return {Cache} the cache object that corresponds to the current trigger
       */
      getTriggerCache: function(trigger) {
         var cache = this.cache;
         if (!cache[trigger]) {
            cache[trigger] = new Cache(this.getTrigger(trigger).ttl);
         }
         return cache[trigger];
      },

      /**
       * Will send an AJAX request based on the trigger provided.
       * If a valid cache entry is found it will be returned and
       * no AJAX-request will be executed.
       */
      sendServerRequest: function(query) {
         var request,
            cache,
            cacheEntry,
            modifiedQuery,
            trigger = this.getTrigger(query.trigger),
            data = {};

         if (trigger.useCache) {
            cache = this.getTriggerCache(query.trigger),
            modifiedQuery = cache.checkForExistingQuery(query.value),
            cacheEntry = cache.getEntry(modifiedQuery);

            if (cacheEntry) {
               return cacheEntry;
            }
         }

         data[trigger.searchKey] = query.value;

         request = $.ajax({
            url: trigger.source,
            method: 'GET',
            dataType: 'json',
            data: data
         })
         .done(function(response) {
            if (trigger.useCache) {
               cache.addEntry(query.value, new CacheEntry(trigger.parse(response)));
            }
         });

         return request;
      },

      /**
       * This method is iterating the array of XXXX's to see
       * if they are still valid. If not the XXXX will be thrown away.
       */
      validateItems: function() {
         var i = 0,
            l = this.idArray.length,
            validatedArray = [],
            content = this.el.value,
            temp, startIndex;

         for (; i < l; i ++) {
            temp = this.idArray[i];
            startIndex = content.indexOf(temp.trigger + temp.name);
            if (startIndex > -1) {
               content = content.substring(startIndex + (temp.trigger + temp.name).length);
               validatedArray.push(temp);
            }
         }

         this.idArray = validatedArray;
      },

      /**
       * Calculates the index for the new XXXX and stores
       * @param {number} position The position wich XXXX was inserted at in the text
       * @param {object} XXXX
       */
      storeItem: function(position, item) {
         var i = 0,
            l = this.idArray.length,
            content = this.el.value,
            temp,
            tempStart,
            index = 0;

         content = content.substring(0, position);

         for (; i < l; i ++) {
            temp = this.idArray[i];
            tempStart = content.indexOf(temp.trigger + temp.name);
            if (tempStart > -1) {
               content = content.substring(tempStart + (temp.trigger + temp.name).length);
               index ++;
            } else {
               break;
            }
         }

         this.idArray.splice(index, 0, item);
         this.validateItems();
      },

      /**
       *
       */
      insertItem: function(item) {
         var position;

         position = this.insertText(item.trigger, item.trigger + item.name);

         if (item.id) {
            this.storeItem(position.start, item);
         }
      },

      insertText: function(trigger, text) {
         var content = this.el.value,
            caretPosition = this.getCaretPosition(),
            end = content.substring(caretPosition),
            start;

         start = content = content.substring(0, caretPosition),

         start = start.substring(0, start.lastIndexOf(trigger));

         this.el.value = start + text + ' ' + end;
         this.setCaretPosition((start + text).length + 1);

         return {
            start: start.length,
            end: (start + text).length
         };
      },

      getQuery: function() {
         var content = this.el.value,
            caretPosition = this.getCaretPosition(),
            triggers = getKeys(this.options.triggers),
            i = 0,
            l = triggers.length,
            trigger,
            checkedContent = content.substring(0, caretPosition);

         for (; i < l; i ++) {
            trigger = this.findTrigger(triggers[i], checkedContent);
            if (trigger) {
               return trigger;
            }
         }
      },

      findTrigger: function(trigger, text) {
         var regex,
            modifiedText,
            resolvedText,
            triggerObj = this.getTrigger(trigger);
         if (text.indexOf(trigger) > -1) {
            modifiedText = text.substring(text.lastIndexOf(trigger) - 1);
            regex = new RegExp(
               '(?:\\B\\' + trigger + ')([' + WORD_CHARS + (triggerObj.allowWhiteSpace ? '(?:\\-| )' : '') + ']+)$'
            );
            if (regex.test(modifiedText)) {
               resolvedText = regex.exec(modifiedText)[1];
               if (triggerObj.allowWhiteSpace && triggerObj.maxWhiteSpace)
               {
                  if (resolvedText.split(' ').length > triggerObj.maxWhiteSpace) {
                     return false;
                  }
               }
               return {
                  trigger: trigger,
                  value: resolvedText
               };
            }
         }

         return false;
      },

      setCaretPosition: function(start, end) {
         var range,
            el = this.el;

         end = end || start;

         if (el.setSelectionRange) {
            el.focus();
            el.setSelectionRange(start, end);
         } else if (el.createTextRange) {
            range = el.createTextRange();
            range.collapse(true);
            range.moveStart('character', start);
            range.moveEnd('character', end);
            range.select();
         }
      },

      /**
       * Found here: http://stackoverflow.com/a/3648244/1397073
       */

      getCaretPosition: function () {
         return this.caretPosition;
      },

      updateCaretPosition: function() {

         var el = this.el,
            range,
            textRange,
            endRange,
            len,
            normalizedValue,
            start,
            caretPosition = 0;

         if (typeof el.selectionStart === 'number') {
            caretPosition = el.selectionStart;
         } else if (el.createTextRange) {
            // For IE8
            range = document.selection.createRange();

            if (range && range.parentElement() === el) {
               len = el.value.length;
               normalizedValue = el.value.replace(/\r\n/g, '\n');

               // Create a working TextRange that lives only in the input
               textRange = el.createTextRange();
               textRange.moveToBookmark(range.getBookmark());

               // Check if the start and end of the selection are at the very end
               // of the input, since moveStart/moveEnd doesn't return what we want
               // in those cases
               endRange = el.createTextRange();
               endRange.collapse(false);

               if (textRange.compareEndPoints('StartToEnd', endRange) > -1) {
                  start = len;
               } else {
                  start = -textRange.moveStart('character', -len);
                  start += normalizedValue.slice(0, start).split('\n').length - 1;
               }
            }
            caretPosition = start;
         }
         this.caretPosition = caretPosition;
      }

   }; // END Controller.prototype
   // }}}

   // Public plugin methods {{{
   var pluginMethods = {
      init: function(options) {
         return this.each(function() {
            var $this = $(this),
               controller = new Controller(this, options);

            $this.data(PLUGIN_NAMESPACE + 'controller', controller);
         });
      },

      // NOTE! This method is not chainable
      getRichContent: function() {
         var $this = $(this),
            controller = $this.data(PLUGIN_NAMESPACE + 'controller');

         return controller.getRichContent();
      },

      setIds: function(ids) {
         var $this = $(this),
            controller = $this.data(PLUGIN_NAMESPACE + 'controller');

         controller.setIds(ids);

         return $this;
      },

      getSelected: function() {
         var controller = $(this).data(PLUGIN_NAMESPACE + 'controller');

         return controller.getIdArray();
      }
   };
   // }}}

   // Plugin definition {{{
   $.fn[PLUGIN_NAMESPACE] = function(method) {
      if (pluginMethods[method]) {
         return pluginMethods[method].apply(this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
         return pluginMethods.init.apply(this, arguments);
      } else {
         $.error('Method ' + method + ' does not exist on jQuery.' + PLUGIN_NAMESPACE);
      }
   };
   // }}}
}));
